<div class="form">
  <h4 class="text-center">Editar información de Link</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-3">
      <div class="mb-3">
        <h5 class="m-0 font-weight-bold">Título de Link</h5>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput placeholder="Título de Producto" [(ngModel)]="this.copyOfLinkInfo.value">
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div class="mb-3">
        <h5 class="m-0 font-weight-bold">Url de Link</h5>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput placeholder="Url de Producto" [(ngModel)]="this.copyOfLinkInfo.url">
        </mat-form-field>
      </div>
    </div>
<!--    <div class="col-3">-->
<!--      <div class="mb-3">-->
<!--        <div>-->
<!--          <h5 class="m-0 font-weight-bold">Sera este un link externo?</h5>-->
<!--        </div>-->
<!--        <mat-button-toggle-group [(ngModel)]="this.copyOfLinkInfo.urlExterno" [value]="copyOfLinkInfo.urlExterno"-->
<!--                                 aria-label="img activo">-->
<!--          <mat-button-toggle [value]="true">-->
<!--            <mat-icon style="color: green">check</mat-icon>-->
<!--          </mat-button-toggle>-->
<!--          <mat-button-toggle [value]="false">-->
<!--            <mat-icon style="color: red">cancel</mat-icon>-->
<!--          </mat-button-toggle>-->
<!--        </mat-button-toggle-group>-->
<!--      </div>-->
<!--    </div>-->
    <div class="col-3">
      <div class="mb-3">
        <div>
          <h5 class="m-0 font-weight-bold">Este link tendra icono?</h5>
        </div>
        <mat-button-toggle-group [(ngModel)]="this.copyOfLinkInfo.imgActivo" [value]="copyOfLinkInfo.imgActivo"
                                 aria-label="img activo">
          <mat-button-toggle [value]="true">
            <mat-icon style="color: green">check</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle [value]="false" (click)="copyOfLinkInfo.img = ''">
            <mat-icon style="color: red">cancel</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>

        <div class="mb-3" *ngIf="copyOfLinkInfo.imgActivo">
          <mat-label>Nombre de icono</mat-label>
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="Nombre de Icono" [(ngModel)]="this.copyOfLinkInfo.img">
            <mat-hint>Escribe nombres de iconos de angular material <br>
              <a target="_blank"
                 href="https://fonts.google.com/icons?selected=Material+Icons"> Más
                Información</a></mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="col-12 d-flex align-items-center">
      <button mat-flat-button aria-label="Add Link" class="save-button" (click)="createLinkFields()">
        Agregar un sublink +
      </button>
    </div>
    <div class="col-12">
      <div class="mb-3 max-height">
        <div *ngFor="let link of this.copyOfLinkInfo.copyDetail, index as i">
          <div class="d-flex align-items-center">
            <h5 class="m-0 font-weight-bold">Link {{i + 1}}</h5>
          </div>
          <div class="row ">
            <div class="col-3">
              <mat-form-field appearance="outline" class=" w-100 me-4">
                <input matInput placeholder="Título de Link" [(ngModel)]="link.value">
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field appearance="outline" class="mb-3 w-100">
                <input matInput placeholder="URL de Link" [(ngModel)]="link.url">
              </mat-form-field>
            </div>
<!--            <div class="col-2">-->
<!--              <div class="mb-3">-->
<!--                <div>-->
<!--                  <h5 class="m-0 font-weight-bold">Sera un link externo?</h5>-->
<!--                </div>-->
<!--                <mat-button-toggle-group [(ngModel)]="link.urlExterno" [value]="link.urlExterno"-->
<!--                                         aria-label="img activo">-->
<!--                  <mat-button-toggle [value]="true">Si</mat-button-toggle>-->
<!--                  <mat-button-toggle [value]="false">No</mat-button-toggle>-->
<!--                </mat-button-toggle-group>-->
<!--              </div>-->
<!--            </div>-->
            <div class="col-3 text-center">
              <div class="mb-3">
                <div>
                  <h5 class="m-0 font-weight-bold">Este link tendra icono?</h5>
                </div>
                <mat-button-toggle-group [(ngModel)]="link.imgActivo" [value]="link.imgActivo"
                                         aria-label="img activo">
                  <mat-button-toggle [value]="true">Si</mat-button-toggle>
                  <mat-button-toggle [value]="false" (click)="link.img = ''">No</mat-button-toggle>
                </mat-button-toggle-group>

                <div class="mb-3" *ngIf="link.imgActivo">
                  <mat-label>Nombre de icono</mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput placeholder="Nombre de Icono" [(ngModel)]="link.img">
                    <mat-hint>Escribe nombres de iconos de angular material <br>
                      <a target="_blank"
                         href="https://www.angularjswiki.com/angular/angular-material-icons-list-mat-icon-list/"> Más
                        Información</a></mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col">
              <button mat-icon-button (click)="deleteLinkField(i)">
                <mat-icon color="warn">delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="mx-3 d-flex justify-content-center">
        </div>
      </div>
    </div>


    <div class="bottom-button">
      <button class="vs-btn-blue" (click)="sendData()" [disabled]="!validateEmptyFields()">
        Editar Link
      </button>
    </div>

  </div>
